var render, staticRenderFns
import script from "./ExpandableTitle.vue?vue&type=script&lang=js&"
export * from "./ExpandableTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExpandableTitle.vue"
export default component.exports